import { DefaultEventEmitter } from "@baseline/runtime/events";
import { View } from "./view";


export class ViewManager<T> extends DefaultEventEmitter<Event>
{
    constructor(views: T)
    {
        super();
        this.views = views;
    }

    show(view: View): void
    {
        const views: View[] = [view];

        for (let { parent } = view; parent; { parent } = parent)
            views.unshift(parent);

        const showing = views.filter(view => !this.visibleViews.includes(view));
        const hiding = this.visibleViews.filter(view => !views.includes(view));

        hiding.forEach(view => view.isVisible = false);
        showing.forEach(view => view.isVisible = true);

        this.visibleViews = views;

        if (showing.length > 0 || hiding.length > 0)
            this.onUpdated();
    };


    views: T;
    visibleViews: View[] = [];


    private onUpdated(): void
    {
        this.emit("update");
    }
}



export namespace ViewManager
{
    export type Event = "update";
}


type Event = ViewManager.Event;
